/**
 * Dashboard — home landing (ADR 0002 decision: keep dashboard as home).
 * Placeholder content for now; the real "ตอนนี้ต้องทำอะไร" NextActionCard +
 * lazy AI brief arrive in B4. STAFF never sees salary cards here.
 */
import { ListTodo, Users, ClipboardCheck, Sparkles } from 'lucide-react';
import { Page } from '../components/Page';
import { useAuth } from '../hooks/useAuth';

export function Dashboard() {
  const { profile, role } = useAuth();

  return (
    <Page title="แดชบอร์ด" subtitle={`สวัสดี ${profile?.user.name ?? ''}`}>
      <div className="rounded-2xl bg-brand-gradient p-5 text-white">
        <div className="flex items-center gap-2 text-sm opacity-90">
          <Sparkles className="w-4 h-4" /> Eval Pilot · AI HRD Platform
        </div>
        <p className="mt-1 text-lg font-display font-semibold">โครงสร้าง React พร้อมใช้งานแล้ว</p>
        <p className="text-sm opacity-90 mt-1">
          บทบาท: {role} — เมนูทางซ้ายปรับตามสิทธิ์ของคุณอัตโนมัติ
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <KpiCard icon={<ListTodo className="w-5 h-5" />} label="งานที่ต้องทำ" value="—" />
        <KpiCard icon={<Users className="w-5 h-5" />} label="พนักงาน" value="—" />
        <KpiCard icon={<ClipboardCheck className="w-5 h-5" />} label="รอบประเมิน" value="—" />
      </div>

      <div className="card p-5">
        <p className="text-sm font-medium">ตอนนี้ต้องทำอะไร</p>
        <p className="text-sm text-gray-500 mt-1">
          NextActionCard + AI brief จะมาในรอบ B4 — ตอนนี้ลองคลิกเมนูทางซ้ายเพื่อทดสอบการนำทาง
        </p>
      </div>
    </Page>
  );
}

function KpiCard({ icon, label, value }: { icon: React.ReactNode; label: string; value: string }) {
  return (
    <div className="card p-4">
      <div className="flex items-center gap-2 text-gray-500">
        <span className="text-brand-600">{icon}</span>
        <span className="text-sm">{label}</span>
      </div>
      <div className="mt-2 text-2xl font-semibold tabular-nums">{value}</div>
    </div>
  );
}
